import React from "react";
import { AlertTriangle, AlertCircle, Info } from "lucide-react";
import { useTranslation } from "react-i18next";

function CodeScanSummary({ scanResult }) {
    const { t } = useTranslation();

    if (!scanResult || scanResult.status !== "COMPLETED") return null;

    const cards = [
        {
            label: t("appPreview.errors") || "Errors",
            count: scanResult.errorCount,
            icon: AlertCircle,
            bg: "bg-red-50",
            text: "text-red-700",
            iconColor: "text-red-500",
        },
        {
            label: t("appPreview.warnings") || "Warnings",
            count: scanResult.warningCount,
            icon: AlertTriangle,
            bg: "bg-yellow-50",
            text: "text-yellow-700",
            iconColor: "text-yellow-500",
        },
        {
            label: t("appPreview.info") || "Info",
            count: scanResult.infoCount,
            icon: Info,
            bg: "bg-blue-50",
            text: "text-blue-700",
            iconColor: "text-blue-500",
        },
    ];

    return (
        <div className="flex gap-3 p-4">
            {cards.map((card) => (
                <div
                    key={card.label}
                    className={`flex-1 rounded-lg p-3 ${card.bg}`}
                >
                    <div className="flex items-center gap-2">
                        <card.icon className={`w-4 h-4 ${card.iconColor}`} />
                        <span className={`text-xs font-medium ${card.text}`}>
                            {card.label}
                        </span>
                    </div>
                    <p className={`text-2xl font-bold mt-1 ${card.text}`}>
                        {card.count}
                    </p>
                </div>
            ))}
        </div>
    );
}

export default React.memo(CodeScanSummary);
